<template>
  <div class="landing">
    <a @click="handClick" href="/analysis/symptom-details" class="report symptom"><span>Symptom Details</span></a>
    <a @click="handClick" href="/analysis/case-frequency/" class="report frequency"><span>Infection Case
        Frequency</span></a>
    <a @click="handClick" href="/analysis/infection-rates/" class="report rates"><span>Infection Rates</span></a>
    <a @click="handClick" href="/analysis/isolation-days" class="report isolation"><span>Isolation Days</span></a>
    <a @click="handClick" href="/analysis/days-of-therapy/" class="report dot"><span>Days of Therapy</span></a>
    <a @click="handClick" href="/analysis/medication-usage/" class="report medication"><span>Medication Usage</span></a>
    <a @click="handClick" href="/analysis/immunization-rates" class="report immunization"><span>Immunization
        Rates</span></a>
    <a v-if="hasUtilization" @click="handClick" href="/analysis/utilization" class="report util"><span>Utilization
        Report</span></a>
    <a v-if="hasProcessSurveillance" @click="handClick" href="/analysis/process-surveillance" class="report uti"><span>UTI Process Surveillance</span></a>
  </div>
</template>

<script>
import auth from "../../auth";
export default {
  name: "analysis-landing",
  components: {},
  data() {
    return {
      hasUtilization: false,
      hasProcessSurveillance: false
    };
  },
  methods: {
    handClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$router.push(e.currentTarget.getAttribute("href"));
    },
  },
  async created() {
    this.hasUtilization = await this.getFeatureFlag('UTILIZATION_REPORT') && auth.userInfo().roles.indexOf("ROLE_ADMIN_STAFF") >= 0 && this.$configStore.utilizationReportEnabled();
    this.hasProcessSurveillance = await this.getFeatureFlag('UTI_PROCESS_SURVEILLANCE');
  },
};
</script>
<style scoped>
.landing {
  display: grid;
  grid-auto-rows: 225px;
  grid-template-columns: repeat(4, 225px);
  align-content: center;
  justify-content: center;
  align-items: center;
  justify-items: center;
  grid-gap: 10px;
  margin: 40px;
}

.report {
  border: 2px solid #cacaca;
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 15px;
  --base-bg: linear-gradient(#f4f4f4, white) no-repeat top left;
  cursor: pointer;
  color: #444;
}

.report:hover {
  border-color: #9d9d9d;
}

.medication {
  background: url("../../assets/pill-svgrepo-com.svg") no-repeat center center / 100px, var(--base-bg);
}

.frequency {
  background: url("../../assets/chart-svgrepo-com.svg") no-repeat center center / 100px, var(--base-bg);
}

.dot {
  background: url("../../assets/annual-calendar-page-svgrepo-com.svg") no-repeat center center / 100px, var(--base-bg);
}

.rates {
  background: url("../../assets/chart-down-svgrepo-com.svg") no-repeat center center / 100px, var(--base-bg);
}

.immunization {
  background: url("../../assets/immunization-rates-vaccine.svg") no-repeat center center / 100px, var(--base-bg);
}

.isolation {
  background: url("../../assets/isolation-days-mask.svg") no-repeat center center / 100px, var(--base-bg);
}

.symptom {
  background: url("../../assets/symptom-svgrepo-com.svg") no-repeat center center / 100px, var(--base-bg);
}

.util {
  background: url("../../assets/download-laptop-svgrepo-com.svg") no-repeat center center / 100px, var(--base-bg);
}
.uti {
  background: url("../../assets/droplets.svg") no-repeat center center / 100px, var(--base-bg);
}

.ai-icon {
  position: relative;
  top: 5px;
  left: -3px;
}

.soon {
  pointer-events: none;
}

.soon span {
  opacity: 0.25;
}

.soon::after {
  content: "Coming soon";
  display: block;
  text-align: center;
  margin-top: 10px;
}

#app .report span {
  position: absolute;
  bottom: 0px;
  font-size: 1.25rem;
  padding: 10px;
  width: 100%;
  text-align: center;
}
</style>
